import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';

@Component({
	selector: 'app-mdp-reinit',
	templateUrl: './mdp-reinit.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./mdp-reinit.component.less']
})
export class MdpReinitComponent implements OnInit {
	textes: any = null;
	globalTxt: any;

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Load the texts for the login page
			this.app.sharedToolsService.loadTexts('txtLoginMdpOublie')
				.subscribe(textes => {
					this.textes = textes;
				});
		});
	}

}
